import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import { toast } from "react-toastify";

const TonnageCompositionStore = create((set, get) => ({
  tonnageCompositionReportData: [],
  loading: false,
  error: null,

  fetchTonnageCompositionReport: async (queryParams) => {
    set({ loading: true, error: null });
    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const tonnageCompositionDataReport = await apiCall({
        url: `${API_BASE_URL1}KpiReport/TonnageCompositionReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      const data = Array.isArray(tonnageCompositionDataReport)
        ? tonnageCompositionDataReport
        : [];

      set({
        tonnageCompositionReportData: data,
        loading: false,
        error: null,
      });

    } catch (error) {
      const status = error.response?.status;
      const message = error.response?.data?.message;


      // 401 Unauthorized
      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";
        set({
          tonnageCompositionReportData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      // 400 Bad Request
      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          tonnageCompositionReportData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      // 404 Not Found
      else if (status === 404) {
        toast.error(error.message );
        set({
          tonnageCompositionReportData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      // 500 Internal Server Error
      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          tonnageCompositionReportData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }

      // Other errors
      else {
        toast.error(error.message || "Something went wrong");
        set({
          tonnageCompositionReportData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }

    } finally {
      set({ loading: false });
    }
  },
}));

export default TonnageCompositionStore;
